export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="rounded-3xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 lg:p-16 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-[-20%] right-[-10%] w-[400px] h-[400px] rounded-full bg-background-50 blur-3xl"></div>
            <div className="absolute bottom-[-30%] left-[-5%] w-[300px] h-[300px] rounded-full bg-background-50 blur-3xl"></div>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-sm font-medium mb-4 whitespace-nowrap">
                移动端体验
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
                随时随地，畅享高清影视
              </h2>
              <p className="mt-4 text-background-50/80 text-base md:text-lg leading-relaxed max-w-lg mx-auto lg:mx-0">
                91免费全面适配手机与平板，通过浏览器即可访问，无需下载任何 App。通勤路上、午休时间，打开手机就能看高清免费电影。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="w-full sm:w-auto px-7 py-3 bg-background-50 text-primary-600 font-semibold rounded-full text-base hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  立即体验
                </a>
                <a
                  href="#faq"
                  className="w-full sm:w-auto px-7 py-3 bg-background-50/15 text-background-50 font-semibold rounded-full text-base hover:bg-background-50/25 transition-colors border border-background-50/30 whitespace-nowrap cursor-pointer text-center"
                >
                  了解更多
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-48 md:w-56 h-[340px] md:h-[400px] rounded-3xl border-4 border-background-50/30 overflow-hidden bg-background-50/10">
                <div className="p-3">
                  <div className="rounded-xl bg-background-50/20 p-3 mb-3">
                    <div className="flex gap-2">
                      <div className="w-14 h-14 rounded-lg bg-background-50/15 flex-shrink-0"></div>
                      <div className="flex-1 space-y-1.5">
                        <div className="h-2.5 bg-background-50/30 rounded-full w-3/4"></div>
                        <div className="h-2 bg-background-50/20 rounded-full w-1/2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="h-12 rounded-lg bg-background-50/10"></div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}